"use client";

import { Container } from "@/components/ui/container";
import { Reveal } from "@/components/ui/reveal";
import { Icon } from "@/components/ui/icon";
import { usps } from "@/lib/data/homepage";

/**
 * USPs — Comparison matrix: 6 differentiators. Each shows what we
 * provide vs what the alternative is, with a clear visual contrast.
 */
export function Usps() {
  const competitors = ["Generic PR", "Legacy Tools", "Manual Teams", "White-Label", "Open-Source Stack", "Boutique Consultancy"];
  const accents = ["var(--color-crimson)", "var(--color-purple)", "var(--color-cyan)", "var(--color-emerald)", "var(--color-amber)", "var(--color-coral)"];
  return (
    <section id="usps" className="relative section-pad">
      <Container>
        <Reveal className="text-center max-w-3xl mx-auto mb-12">
          <span className="inline-flex items-center gap-2 px-3 py-1 rounded-full glass eyebrow-tiny text-[var(--color-crimson)]">
            <span className="h-1.5 w-1.5 rounded-full bg-[var(--color-crimson)]" />
            Our USPs
          </span>
          <h2 className="mt-6">
            Why Perception X2 Is Different
          </h2>
        </Reveal>

        <div className="rounded-3xl glass overflow-hidden">
          <div className="grid grid-cols-[1fr_1.2fr_1fr] gap-px bg-[rgb(var(--border)/0.15)]">
            {/* Header row */}
            <div className="bg-[rgb(var(--bg))] p-4 eyebrow-tiny font-semibold text-[rgb(var(--fg-subtle))]">
              Dimension
            </div>
            <div className="bg-[rgb(var(--bg))] p-4 eyebrow-tiny font-semibold text-[var(--color-crimson)] flex items-center gap-2">
              <span className="h-1.5 w-1.5 rounded-full bg-[var(--color-crimson)]" />
              Perception X2
            </div>
            <div className="bg-[rgb(var(--bg))] p-4 eyebrow-tiny font-semibold text-[rgb(var(--fg-subtle))]">
              Alternative
            </div>

            {/* Rows */}
            {usps.map((u, i) => (
              <Reveal key={u.title} delay={i * 50} className="contents">
                <div className="bg-[rgb(var(--bg))] p-5 flex items-start gap-3">
                  <span
                    className="grid place-items-center h-8 w-8 rounded-lg shrink-0"
                    style={{
                      background: `color-mix(in oklch, ${accents[i]} 18%, transparent)`,
                      boxShadow: `inset 0 0 0 1px color-mix(in oklch, ${accents[i]} 35%, transparent)`,
                    }}
                  >
                    <Icon name={u.icon} className="h-4 w-4" style={{ color: accents[i] }} />
                  </span>
                  <div>
                    <div className="font-semibold text-sm leading-tight">{u.title}</div>
                  </div>
                </div>
                <div className="bg-[rgb(var(--bg))] p-5">
                  <p className="text-body-xs leading-relaxed text-[rgb(var(--fg))]">
                    {u.desc}
                  </p>
                </div>
                <div className="bg-[rgb(var(--bg))] p-5">
                  <p className="text-body-xs leading-relaxed text-[rgb(var(--fg-subtle))] line-through opacity-60">
                    {competitors[i]}
                  </p>
                  <p className="text-[0.75rem] text-[rgb(var(--fg-subtle))] mt-2 italic">
                    Reactive, partial, or unproven at scale
                  </p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </Container>
    </section>
  );
}
